import { tasksList_template } from '~/components/templates/tasksList_template';
import { vnModule_knockoutJS } from '@valnet/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '@valnet/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { XMLHttpRequestHandler_requestType } from '@valnet/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { vn_app_zone_notification } from '@valnet/vnApp/vn_app_zone_notification';
import { validationsList_template } from '@valnet/vnKnockoutJsTemplates/validationsList_template';
import { header } from './header';
import { hideLoadingOverlay, showLoadingOverlay } from '~/utils/listLoading';
export class tasks extends vnModule_knockoutJS {
    //
    // implementation of base class [vnModule]
    getModuleName() {
        return "tasks";
    }
    getListResultsElement() {
        return this.tasksList?.builtTemplate?.querySelector?.("#list-results")
            ?? document.getElementById("list-results");
    }
    startListLoading() {
        const listResults = this.getListResultsElement();
        if (listResults) {
            showLoadingOverlay(listResults, 'Loading tasks...');
        }
    }
    stopListLoading() {
        const listResults = this.getListResultsElement();
        if (listResults) {
            hideLoadingOverlay(listResults);
        }
    }
    getTimelineElement() {
        return this.tasksList?.builtTemplate?.querySelector?.("#timeline")
            ?? document.getElementById("timeline");
    }
    //
    // implementation of base class [vnModule]
    buildContent() {
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle("Tasks");
        this.validationsList = new validationsList_template("validationList", this.viewModel, this);
        this.tasksList = new tasksList_template("tasks", this.viewModel, this);
        return [this.validationsList.build(), this.tasksList.build()];
    }
    // implementation of base class [vnModule]
    fillPage() {
        window.requestAnimationFrame(() => {
            this.getListFormData();
        });
    }
    //
    // required from template [usersList_template]
    paginationOnPageClick() {
        this.getListData();
    }
    //
    // required from template [accountsList_template]
    reorderTasks() {
        this.getListData();
    }
    getListFormData() {
        this.startListLoading();
        this.XHRHdl = new XMLHttpRequestHandler('/api/tasks/list_from_data/', [], this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }
    onFilterRequestReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            try {
                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response || '{}');
                    if (req.request.status == 200) {
                        try {
                            obj.updateFilters(responseParsed);
                            obj.updateViewModelFromPath();
                            obj.getListData();
                        }
                        catch (error) {
                            console.error(error);
                            obj.stopListLoading();
                        }
                    }
                });
            }
            catch (error) {
                console.error(error);
            }
            finally {
                if (req.request.status !== 200) {
                    obj.stopListLoading();
                }
            }
        };
    }
    getMultipleAutoCompleteSuggestions(idSourceElement, keyword) {
        switch (idSourceElement) {
            case 'executerFilterAutocomplete':
                this.getTaskExecuterSuggestions(keyword, idSourceElement);
                break;
            default:
                console.log(`getMultipleAutoCompleteSuggestions not implemented for ${idSourceElement}`);
                break;
        }
    }
    getTaskExecuterSuggestions(keyword, idSourceElement, limit = 5) {
        if (idSourceElement in this.XHRHdls) {
            this.XHRHdls[idSourceElement].cancelAndReset();
        }
        let subViewModel = { filter: {
                keyword: keyword,
                limit: limit || 5,
            } };
        let req_url = '/api/task-executer/search/';
        let req_params = [];
        req_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls[idSourceElement] = new XMLHttpRequestHandler(req_url, req_params, this);
        this.XHRHdls[idSourceElement].onReadyStateFunction = this.onGetTaskExecuterSuggestionsReturn;
        this.XHRHdls[idSourceElement].execute();
    }
    onGetTaskExecuterSuggestionsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.taskExecuters) {
                    obj.tasksList.executerAutocomplete.setItems(responseParsed.data.taskExecuters);
                }
            });
        };
    }
    onAutocompleteOptionChange(idElement) {
        this.getListData();
    }
    onAutocompleteInputClick(idElement) {
    }
    onAutocompleteInputClear(idElement) {
        this.getListData();
    }
    filterMultipleSelectorOnChange(elem) {
        this.tasksList.resetPageNumber();
        this.tasksList.resetOrderParameters();
        this.getListData();
    }
    getListData() {
        this.startListLoading();
        try {
            const requests = this.XHRHdl;
            if ("getListData" in requests) {
                requests["getListData"].cancelAndReset();
            }
            let subViewModel = this.tasksList.getViewModelForRequest();
            let usrReq_url = '/api/tasks/get/';
            let usrReq_params = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);
            requests["getListData"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
            requests["getListData"].onReadyStateFunction = this.onDataRequestReturn;
            requests["getListData"].execute();
        }
        catch (error) {
            console.error(error);
            this.stopListLoading();
        }
    }
    /**
     * @param req
     * @param obj
     * @protected
     */
    onDataRequestReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            try {
                obj.manageResponse(req, obj, function () {
                    const responseParsed = JSON.parse(req.request.response || '{}');
                    const execTime = Math.round((new Date().getTime() - req._requestStartTime) / 1000 * 100) / 100;
                    obj.updateList(responseParsed, execTime);
                    obj.tasksList.autoRefresh.callRefresh();
                });
            }
            catch (error) {
                console.error(error);
            }
            finally {
                obj.stopListLoading();
            }
        };
    }
    onUpdateError() {
    }
    errorHandler(req, obj) {
        obj.getVnAppZone().showNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, "An error occured."));
        console.log("ERROR");
    }
    updateList(responseParsed, execTime = 0) {
        this.tasksList.setPagination(responseParsed?.totalCount ?? 0);
        this.tasksList.setResultPage(responseParsed?.totalCount ?? 0, execTime);
        let tasks = [];
        const rows = Array.isArray(responseParsed?.data) ? responseParsed.data : [];
        if (rows.length > 0) {
            tasks = rows.map(item => {
                let task = item?.['0'] ?? item;
                if (!task) {
                    return null;
                }
                if (task.dateExecuted && task.formattedDateUpdated) {
                    const dateUpdate = new Date(task.formattedDateUpdated);
                    const dateExecuted = new Date(task.dateExecuted);
                    const diff = dateUpdate.getTime() - dateExecuted.getTime();
                    const hours = Math.floor(diff / 1000 / 60 / 60);
                    const formattedHours = (hours.toString().length < 2 ? '0'.repeat(2 - hours.toString().length) : '') + hours.toString();
                    const minutes = Math.floor((diff - (hours * 1000 * 60 * 60)) / 1000 / 60);
                    const formattedMinutes = (minutes.toString().length < 2 ? '0'.repeat(2 - minutes.toString().length) : '') + minutes.toString();
                    const seconds = Math.floor((diff - (hours * 1000 * 60 * 60) - (minutes * 1000 * 60)) / 1000);
                    const formattedSeconds = (seconds.toString().length < 2 ? '0'.repeat(2 - seconds.toString().length) : '') + seconds.toString();
                    task.executionTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
                }
                else {
                    task.executionTime = ``;
                }
                return task;
            }).filter(Boolean);
        }
        this.tasksList.setTasks(tasks);
    }
    filterDropDownOnChange() {
        return 1;
    }
    filterSingleGroupSelectorOnChange(elem) {
        this.tasksList.resetPageNumber();
        this.tasksList.resetOrderParameters();
        this.getListData();
    }
    // required from template [tasksList_template]
    filterSimpleOnChange() {
        this.tasksList.resetPageNumber();
        this.tasksList.resetOrderParameters();
        this.getListData();
    }
    updateFilters(responseParsed) {
        if (Array.isArray(responseParsed?.operations)) {
            this.tasksList.setOperationFilterItems(responseParsed.operations);
        }
        if (Array.isArray(responseParsed?.status)) {
            this.tasksList.setStatusFilterItems(responseParsed.status);
        }
        if (Array.isArray(responseParsed?.updateStatuses)) {
            this.tasksList.setUpdateStatuses(responseParsed.updateStatuses);
        }
        if (responseParsed?.idUpdateDelete != null) {
            this.tasksList.setIdUpdateDelete(responseParsed.idUpdateDelete);
        }
        this.tasksList.setPipelineFilterItems(responseParsed?.pipelines ?? []);
        if (responseParsed?.permissions) {
            this.tasksList.setPermissions(responseParsed.permissions);
        }
        if (Array.isArray(responseParsed?.brands)) {
            this.tasksList.setBrandFilterItems(responseParsed.brands);
        }
    }
    filterDropdownOnChange(elem) {
        if (elem != "updateStatuses") {
            this.tasksList.resetPageNumber();
            this.tasksList.resetOrderParameters();
            this.getListData();
        }
    }
    resetPageNumber() {
        this.tasksList.resetPageNumber();
    }
    filterSimpleCancel() {
    }
    deleteTask(task) {
        let formReq_params = [];
        let XHRHdl = new XMLHttpRequestHandler('/api/tasks/delete/' + task.id, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onDeleteReturn;
        XHRHdl.execute();
    }
    filterAutoRefreshStatusOnChange() {
    }
    /**
     * Handles delete response.
     *
     * @param req
     * @param obj
     * @return {function(): void}
     */
    onDeleteReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task deleted successfully!');
                obj.getVnAppZone().showNotificationToModule();
                obj.validationsList.clearMessages();
                obj.getListData();
            });
        };
    }
    rescheduleTask() {
        const timeline = this.getTimelineElement();
        if (timeline) {
            showLoadingOverlay(timeline, 'Loading schedule...');
        }
        const requests = this.XHRHdl;
        if ("rescheduleTask" in requests) {
            requests["rescheduleTask"].cancelAndReset();
        }
        let subViewModel = this.tasksList.getViewModelForRequest();
        let usrReq_url = '/api/tasks/rescheduleBlocks/get/';
        let usrReq_params = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        requests["rescheduleTask"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        requests["rescheduleTask"].onReadyStateFunction = this.onRescheduleTaskReturn;
        requests["rescheduleTask"].execute();
    }
    onRescheduleTaskReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.tasksList.setTimeline(responseParsed.timeline);
            });
            const timeline = obj.getTimelineElement();
            if (timeline) {
                hideLoadingOverlay(timeline);
            }
        };
    }
    saveRescheduleTask() {
        const timeline = this.getTimelineElement();
        if (timeline) {
            showLoadingOverlay(timeline, 'Saving schedule...');
        }
        const requests = this.XHRHdl;
        if ("saveRescheduleTask" in requests) {
            requests["saveRescheduleTask"].cancelAndReset();
        }
        let subViewModel = this.tasksList.getViewModelForRequest();
        let usrReq_url = '/api/tasks/reschedule/save/';
        let usrReq_params = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        requests["saveRescheduleTask"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        requests["saveRescheduleTask"].mode = XMLHttpRequestHandler_requestType.POST;
        requests["saveRescheduleTask"].onReadyStateFunction = this.onSaveRescheduleTaskkReturn;
        requests["saveRescheduleTask"].execute();
    }
    onSaveRescheduleTaskkReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                //let responseParsed = JSON.parse(req.request.response);
                obj.tasksList.onClickCancelReschedule();
                const timeline = obj.getTimelineElement();
                if (timeline) {
                    hideLoadingOverlay(timeline);
                }
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task rescheduled successfully!');
                obj.getVnAppZone().showNotificationToModule();
                obj.validationsList.clearMessages();
                obj.getListData();
            });
        };
    }
    updateTask(ids, idStatus) {
        let formReq_params = [];
        let data = { ids: ids, idStatus: idStatus };
        formReq_params.push(["data", ko.toJSON(data)]);
        let XHRHdl = new XMLHttpRequestHandler('/api/tasks/update/', formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onUpdateReturn;
        XHRHdl.execute();
    }
    /**
     * Handles delete response.
     *
     * @param req
     * @param obj
     * @return {function(): void}
     */
    onUpdateReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task updated successfully!');
                obj.getVnAppZone().showNotificationToModule();
                obj.validationsList.clearMessages();
                obj.getListData();
            });
        };
    }
    /**
     * Hook.
     *
     * Redirects to create task page.
     */
    addTask() {
        page('/tasks/add');
    }
    /**
     * Hook.
     *
     * refresh the data on request
     */
    autoRefresh() {
        this.getListData();
    }
}
